import TimetablePublishModal from './TimetablePublishModal';

export default TimetablePublishModal;
